import { render, staticRenderFns } from "./CollaboratingUsersPreview.vue?vue&type=template&id=7547d2ba&scoped=true&"
import script from "./CollaboratingUsersPreview.vue?vue&type=script&lang=js&"
export * from "./CollaboratingUsersPreview.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratingUsersPreview.vue?vue&type=style&index=0&id=7547d2ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7547d2ba",
  null
  
)

export default component.exports